<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs class="page__tabs" hide-slider>
          <v-tab
            :key="i"
            :to="tab.value"
            v-for="(tab, i) in pageParams.tabs"
            :active-class="'white--text financial--background'"
          >
            <span :class="hasLateSlips && tab.icon ? 'enterprise--color' : ''">
              {{ !mobile ? tab.title : tab.titleMobile }}
              <i
                v-if="hasLateSlips && tab.icon"
                :class="`${tab.icon} side-text--icon`"
              />
            </span>
          </v-tab>
        </v-tabs>
        <div class="payment-slip-in-delay__description">{{ description }}</div>
        <div
          v-if="discountCampaignDescription"
          class="payment-slip-in-delay__description"
        >
          {{ discountCampaignDescription }}
        </div>
        <screen-loading v-if="loadingItems"></screen-loading>
        <div v-else-if="error" class="empty-state">
          {{ $t('responses.error') }}
        </div>
        <div v-else>
          <template
            v-if="
              !hasAnticipationSlips &&
              !hasLateError &&
              !hasSolicitationsInProgress
            "
          >
            <empty-state-card :icon="enums.paymentSlipWaitingState.icon">
              <div slot="message">
                Você
                <b>não possui boletos para antecipar.</b>
              </div>
            </empty-state-card>
          </template>
          <template
            v-else-if="
              (debitBlock || hasLateError) && !hasSolicitationsInProgress
            "
          >
            <empty-state-card icon="alert">
              <div slot="message" class="error--color">
                <p class="waiting-state__title">
                  <span>
                    <b>Operação não permitida.</b>
                  </span>
                </p>
                <p class="waiting-state__text">
                  <span>
                    Você possui boleto(s) em atraso, para regularizar o(s)
                    pagamento(s),
                    <router-link
                      class="error--color font-weight-bold"
                      :to="{ name: 'latePaymentSlip' }"
                      tag="a"
                    >
                      <u>clique aqui</u>
                    </router-link>
                  </span>
                </p>
              </div>
            </empty-state-card>
          </template>
          <template v-else>
            <empty-state-card messagePadding="2%" messageClass="xs12 md12 lg12">
              <template slot="message">
                <span class="payment-slip-in-delay__febraban font-weight-bold">
                  {{ latePaymentSlipTooltip }}
                </span>
              </template>
            </empty-state-card>
            <span v-for="(contract, i) in allowedContracts" :key="i">
              <v-card
                v-if="
                  anticipationPositionData[contract.id] === null ||
                  anticipationPositionData[contract.id] ||
                  contractsData[contract.id].solicitations
                "
                class="mt-2 mb-2"
              >
                <v-card-title class="pt-headline financial--color">{{
                  getContractTitle(contract)
                }}</v-card-title>
                <screen-loading
                  v-if="anticipationPositionData[contract.id] === null"
                  margin="20px 25%"
                ></screen-loading>
                <v-card-text v-else>
                  <p
                    v-if="
                      config.texts.lateSlipDetachedContractMessage &&
                      contract.type === enums.contractValues.detached
                    "
                    class="payment-slip-in-delay__description"
                    style="margin: 2px 18px"
                  >
                    {{ config.texts.lateSlipDetachedContractMessage }}
                    <router-link
                      v-if="ticketCrmEnabled"
                      style="color: var(--financial-color); font-weight: bold"
                      :to="{ name: 'ticketForm' }"
                      tag="a"
                    >
                      <u>Abrir nova solicitação</u>
                    </router-link>
                  </p>

                  <empty-state-card
                    v-if="
                      !inDelaySolicitationAllowed &&
                      contractsData[contract.id].solicitationStep ===
                        SOLICITATIONS_PAGE_STEPS.INITIAL
                    "
                    icon="alert"
                  >
                    <div slot="message" class="error--color">
                      <p class="waiting-state__title">
                        <span>
                          <b>Operação não permitida.</b>
                        </span>
                      </p>

                      <p class="waiting-state__text">
                        <span
                          >Em caso de dúvidas, favor entrar em contato com a
                          Central de Relacionamento.</span
                        >
                      </p>

                      <p class="waiting-state__text">
                        <router-link
                          v-if="ticketCrmEnabled"
                          class="error--color font-weight-bold"
                          :to="{ name: 'ticketForm' }"
                          tag="a"
                        >
                          <u>Abrir nova solicitação</u>
                        </router-link>
                      </p>
                    </div>
                  </empty-state-card>
                  <div v-else class="table-stepper-container">
                    <template
                      v-if="
                        (!contractsData[contract.id].solicitations ||
                          contractsData[contract.id].solicitations.length ==
                            0) &&
                        (!anticipationPositionData[contract.id] ||
                          anticipationPositionData[contract.id].length == 0)
                      "
                    >
                      <empty-state-card
                        :icon="enums.paymentSlipWaitingState.icon"
                      >
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>{{ pageParams.emptyState.anticipation }}</b>
                            </span>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                    <template
                      v-else-if="!contractsData[contract.id].systemDischarge"
                    >
                      <TableStepper
                        v-model="contractsData[contract.id].solicitationStep"
                        v-bind="enums.paymentSlipRequestSteps"
                        :no-data-text="pageParams.emptyState.anticipation"
                        :items="contractsData[contract.id].solicitations"
                        :contractPositions="
                          anticipationPositionData[contract.id]
                        "
                        :unitFinancialPositions="anticipationPositionData"
                        :loading="loadingApp"
                        :headers="
                          contractsData[contract.id].solicitationStep ===
                          SOLICITATIONS_PAGE_STEPS.INITIAL
                            ? slipSelectionHeaders
                            : solicitationReadyHeaders
                        "
                        :expand-column="expandColumn"
                        :slipDetailsHeaders="slipDetailsHeaders"
                        :partialUnifiedHeaders="partialUnifiedHeaders"
                        :mode="mode"
                        @updateSelected="
                          (v) => {
                            contractsData[contract.id].selected = v;
                          }
                        "
                        buttonClass="white--text financial--background"
                        totalKey="paidValue"
                        totalLabel="Total"
                        sort-icon="bexsicon-down"
                        itemKey="id"
                        :buttonText="enums.paymentSlipRequestButtonText"
                        @buttonClicked="solicitateSlip(contract.id)"
                        :buttonLoading="loadingSolicitation"
                        :activeClass="tableActiveClass"
                        :footerEmptyCols="footerEmptyCols"
                      >
                        <template #col-paidValue="props">
                          <text-field
                            class="input-slim"
                            ref="paidValue"
                            v-model.lazy="props.item.paidValue"
                            v-money="money"
                            required
                            :rules="
                              validateValue(
                                props.item.slipValue,
                                props.item.paidValue
                              )
                            "
                          ></text-field>
                        </template>
                        <template #step2>
                          <empty-state-card
                            :icon="enums.paymentSlipWaitingState.icon"
                          >
                            <div slot="message">
                              <p
                                :class="`waiting-state__title ${
                                  contractsData[contract.id].error
                                    ? 'error--text'
                                    : ''
                                }`"
                              >
                                {{
                                  $t(
                                    enums[
                                      contractsData[contract.id].error
                                        ? 'paymentSlipError'
                                        : 'paymentSlipWaitingState'
                                    ].title
                                  )
                                }}
                              </p>
                              <p class="waiting-state__text">
                                {{
                                  $t(
                                    enums[
                                      contractsData[contract.id].error
                                        ? 'paymentSlipError'
                                        : 'paymentSlipWaitingState'
                                    ].firstLine,
                                    { slipTimeoutHours }
                                  )
                                }}
                                <router-link
                                  v-if="
                                    ticketCrmEnabled &&
                                    contractsData[contract.id].error
                                  "
                                  :to="{ name: 'ticketForm' }"
                                  tag="a"
                                >
                                  <u>{{ enums.paymentSlipError.link }}</u>
                                </router-link>
                              </p>
                            </div>
                          </empty-state-card>
                        </template>
                        <template slot="step3Items" slot-scope="props">
                          <td class="text-xs-center">
                            {{ formatDate(props.item.expirationDate) }}
                          </td>
                          <td
                            v-if="discountCampaign.hasDiscountCampaign"
                            class="text-xs-center bold--text"
                          >
                            -
                          </td>
                          <td
                            v-if="discountCampaign.hasDiscountCampaign"
                            class="text-xs-center bold--text"
                          >
                            -
                          </td>
                          <td class="text-xs-center bold--text">
                            {{ formatMoney(props.item.paymentTotal) }}
                          </td>
                          <td class="text-xs-center">
                            <PaymentButton
                              :item="props.item"
                              :email="email"
                              :cellphone="cellphone"
                              :buttonClass="'financial--background table-btn'"
                              @openSlip="paySlip(props.item)"
                              :sendByEmail="sendSlipByEmailAnticipation"
                              :sendBySms="sendSlipBySmsAnticipation"
                            >
                              <template v-slot:tooltip>
                                <v-tooltip
                                  z-index="99"
                                  top
                                  color="grey lighten-3"
                                  max-width="300"
                                >
                                  <span class="tooltip__text no-print">{{
                                    latePaymentSlipTooltip
                                  }}</span>
                                  <span slot="activator">
                                    <i
                                      class="bexsicon-info tooltip__icon indelay-slips-tooltip"
                                    />
                                  </span>
                                </v-tooltip>
                              </template>
                            </PaymentButton>
                          </td>
                          <td
                            v-if="!discountCampaign.hasDiscountCampaign"
                            class="text-xs-center bold--text"
                          ></td>
                        </template>
                      </TableStepper>
                    </template>
                    <template v-else>
                      <empty-state-card icon="alert">
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>
                                Estamos aguardando o pagamento do boleto gerado
                                {{
                                  contractsData[contract.id].solicitations
                                    ? ' com vencimento no dia ' +
                                      formatDate(
                                        contractsData[contract.id].solicitations
                                          .expirationDate
                                      )
                                    : ''
                                }}.
                              </b>
                            </span>
                          </p>
                          <p class="waiting-state__text">
                            <span>{{ waitingText }}</span>
                          </p>
                          <p class="waiting-state__text">
                            <router-link
                              v-if="ticketCrmEnabled"
                              class="financial--color font-weight-bold"
                              :to="{ name: 'ticketForm' }"
                              tag="a"
                            >
                              <u>Abrir nova solicitação</u>
                            </router-link>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </span>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import TableStepper from '@/components/financial/TableStepper';
import EmptyStateCard from '@/components/layout/EmptyStateCard';
import PaymentButton from '@/components/financial/PaymentButton';
import notificationTypes from '@/utils/notificationTypes';
import getSlipUrl from '@/services/getSlipUrl';
import TextField from '@/components/fields/TextField';
import { VMoney } from 'v-money';
import {
  APP,
  CONFIG,
  NOTIFICATIONS,
  ROLES,
  SOLICITATE_TYPE,
  USER,
  TICKET_CRM,
  SOLICITATIONS_PAGE_STEPS,
} from '../../utils/constants';

const initialContractsData = {
  selected: [],
  slips: [],
  solicitations: [],
  error: false,
  solicitationStep: SOLICITATIONS_PAGE_STEPS.INITIAL,
  systemDischarge: false,
};

export default {
  name: 'anticipationPaymentSlip',
  components: {
    ModulePage,
    ScreenLoading,
    TableStepper,
    EmptyStateCard,
    TextField,
    PaymentButton,
  },
  computed: {
    pageParams() {
      return this.$store.getters[APP.PAGES].paymentSlip;
    },
    positionData() {
      return this.$store.getters['solicitations/unitFinancialPositions'];
    },
    anticipationPositionData() {
      return this.positionData[this.mode];
    },
    hasAnticipationSlips() {
      return this.$store.getters['solicitations/hasAnticipationSlips'];
    },
    hasLateError() {
      return this.$store.getters['solicitations/hasLateError'];
    },
    imobmeUser() {
      return this.$store.getters[USER.GET_IMOBME_DATA];
    },
    unitContracts() {
      return this.selectedUnit.contracts;
    },
    hasSolicitationsInProgress() {
      return this.unitContracts.some(
        (contract) =>
          (this.contractsData[contract.id].solicitations || []).length
      );
    },
    allSolicitations() {
      return this.unitContracts.reduce(
        (contractsSolicitations, contract) =>
          contractsSolicitations.push(
            ...this.contractsData[contract.id].solicitations
          ),
        []
      );
    },
    discountCampaign() {
      return this.$store.getters['solicitations/discountCampaign'];
    },
    inDelaySolicitationAllowed() {
      return this.$store.getters['solicitations/inDelaySolicitationAllowed'];
    },
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    ticketCrmEnabled() {
      return this.$store.getters[TICKET_CRM.GET_ENABLED];
    },
    financialRule() {
      return this.$store.getters[CONFIG.GET_FINANCIAL_RULE];
    },
    debitBlock() {
      return (
        this.unitContracts.some((contract) => contract.debitBlock) || false
      );
    },
    latePaymentSlipTooltip() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .latePaymentSlipTooltip;
    },
    allowedContracts() {
      const { ANTICIPATION_SLIPS } = enums.financialModules;
      return this.getAllowedContracts(ANTICIPATION_SLIPS, this.unitContracts);
    },
    slipTimeoutHours() {
      return this.$store.getters[CONFIG.GET_SLIP_TIMEOUT_HOURS];
    },
    slipSelectionHeadersConfig() {
      return [
        {
          text: '',
          value: 'selected',
          align: 'center',
          class: 'no-print',
          sortable: false,
          width: '40px',
        },
        {
          text: ' ',
          value: 'slipsUnion',
          align: 'left',
          class: 'no-print',
          sortable: false,
          width: '40px',
        },
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          value: 'expirationDate',
          align: 'center',
          sortable: false,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Desconto Campanha**',
          value: 'discount',
          align: 'center',
          sortable: false,
          visible: this.discountCampaign.hasDiscountCampaign,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor Atualizado',
          value: 'slipValue',
          align: 'center',
          sortable: false,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor a pagar*',
          value: 'paidValue',
          align: 'center',
          sortable: false,
          width: '200px',
          class: 'text-xs-center',
        },
        {
          text: '',
          value: '',
          align: 'center',
          sortable: false,
          class: 'text-xs-center',
          visible: !this.discountCampaign.hasDiscountCampaign,
        },
      ];
    },
    solicitationReadyHeadersConfig() {
      return [
        {
          text: 'Vencimento',
          value: 'expirationDate',
          align: 'center',
          sortable: false,
          visible: true,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Desconto Campanha',
          value: 'discount',
          align: 'center',
          sortable: false,
          visible: this.discountCampaign.hasDiscountCampaign,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor Atualizado',
          value: 'updatedValueEndMonth',
          align: 'center',
          sortable: false,
          class: 'text-xs-center',
          visible: true,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor a pagar',
          value: 'paidValue',
          align: 'center',
          sortable: false,
          class: 'text-xs-center',
          visible: true,
        },
        {
          text: '',
          value: '',
          align: 'center',
          sortable: false,
          class: 'text-xs-center',
          visible: !this.discountCampaign.hasDiscountCampaign,
        },
      ];
    },
    slipDetailsHeadersConfig() {
      return [
        {
          text: 'Contrato',
          value: 'type',
          align: 'center',
          showMobile: true,
        },
        {
          text: 'Descrição',
          value: 'contractTitle',
          formatter: (v, item) => this.getContractTitle(item),
          align: 'center',
          showMobile: false,
        },
        {
          text: 'Total',
          value: 'partialValue',
          align: 'center',
          formatter: this.formatMoney,
        },
      ];
    },
    partialUnifiedHeaders() {
      return [
        {
          text: ' ',
          value: 'slipsUnion',
          align: 'left',
          class: 'no-print',
          sortable: false,
          width: '40px',
        },
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          value: 'expirationDate',
          align: 'center',
          sortable: false,
          formatter: this.formatUtcDate,
        },
        {
          text: 'Valor Atualizado',
          value: 'updatedValueEndMonth',
          align: 'center',
          sortable: false,
          formatter: this.formatMoney,
        },
        {
          text: 'Valor Parcela',
          value: 'value',
          align: 'center',
          sortable: false,
          width: '200px',
          class: 'text-xs-center',
          formatter: (v, item, extraInfo, headerValue) =>
            extraInfo == this.expandColumn
              ? this.formatMoney(item[headerValue])
              : this.formatUnifiedValue(v, item, extraInfo, headerValue),
        },
      ];
    },

    slipSelectionHeaders() {
      return this.visibleHeaders(this.slipSelectionHeadersConfig);
    },
    solicitationReadyHeaders() {
      return this.visibleHeaders(this.solicitationReadyHeadersConfig);
    },
    slipDetailsHeaders() {
      return this.visibleHeaders(this.slipDetailsHeadersConfig);
    },
  },
  data() {
    return {
      mode: 'anticipation',
      tableActiveClass:
        'financial--background financial--border-color all--white',
      expandColumn: 'slipsUnion',
      SOLICITATIONS_PAGE_STEPS,
      loadingSolicitation: false,
      description: '',
      discountCampaignDescription: '',
      waitingText:
        'Aguarde 4 dias após o vencimento para gerar novos boletos. Em caso de dúvida, entre em contato com a Central de Relacionamento.',
      error: false,
      loadingItems: false,
      contractsData: {
        /*
        123: {
          selected: [],
          slips: [],
          solicitations: [],
          error: false,
          solicitationStep: SOLICITATIONS_PAGE_STEPS.INITIAL,
          systemDischarge: false,
        },
      */
      },
      hasLateSlips: false,
      footerEmptyCols: 1,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      email: '',
      cellphone: {
        countryCode: '+55',
        areaCode: '',
        number: '',
      },
    };
  },

  directives: { money: VMoney },

  created() {
    bus.$on('unit:change', this.setItems);
    bus.$on('unit:update', this.setItems);

    for (const { id: contractId } of this.unitContracts) {
      this.contractsData[contractId] = { ...initialContractsData };
    }

    this.email = this.user.email;
    if (this.imobmeUser && this.imobmeUser.cellphone) {
      const { number, areaCode, countryCode } = this.imobmeUser.cellphone;
      this.cellphone = { number, areaCode, countryCode: countryCode || '+55' };
    }

    this.description = this.pageParams.texts.inDelayDescription;

    this.setItems();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.setItems);
    bus.$off('unit:update', this.setItems);
  },
  methods: {
    visibleHeaders(headers, mobile = this.mobile) {
      return headers.filter(
        (header) =>
          header.visible !== false &&
          (mobile ? header.showMobile !== false : header.showDesktop !== false)
      );
    },
    setItems(unitObj = null) {
      this.formatSelecteds();
      this.getItems();
    },

    formatSelecteds() {
      for (const { id } of this.unitContracts) {
        this.contractsData[id].solicitationStep =
          SOLICITATIONS_PAGE_STEPS.INITIAL;
      }
    },

    validateValue(currentValue, newValue) {
      let message = [];
      const value =
        typeof newValue === 'string'
          ? this.parseMoneyComma(newValue)
          : newValue;

      const balance = currentValue - value;
      if (value !== currentValue) {
        if (value <= 0) {
          message.push(`O valor digitado não pode ser menor ou igual a zero!`);
        }
        if (value > currentValue) {
          message.push(
            `O valor digitado não pode ser maior do que ${this.formatMoney(
              currentValue
            )}!`
          );
        }
        if (value < this.financialRule.minAmortization) {
          message.push(
            `O valor mínimo para antecipação é de ${this.formatMoney(
              this.financialRule.minAmortization
            )}!`
          );
        }
        if (balance < this.financialRule.minBalance) {
          message.push(
            `O valor restante não pode ser menor do que ${this.formatMoney(
              this.financialRule.minBalance
            )}!`
          );
        }
      }

      return message;
    },

    paySlip(slip) {
      if (slip.slipUrl.hash) {
        window.open(getSlipUrl(slip.slipUrl.hash));
      } else {
        window.open(slip.slipUrl);
      }

      const notification = {
        id: slip._id,
        type: notificationTypes.LATE_SLIPS,
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, {
        ctx: this,
        notification,
      });
      const contract = this.unitContracts.find(
        ({ id }) => id === slip.contractId
      );
      const traceInfo = {
        contractId: slip.contractId,
        contractType: contract.type,
        detachedType: this.getContractTitle(contract),
        paymentTotal: slip.paymentTotal,
        solicitationCode: slip.solicitationCode,
        expirationDate: slip.expirationDate,
        parcels: slip.parcels,
        url: slip.slipUrl,
      };
      const traceAction = enums.logTraceActions.anticipationPaymentSlipDownload;
      this.createTrace(traceAction, traceInfo);
    },

    async solicitateSlip(contractId) {
      if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
      if (this.loadingSolicitation) return;
      try {
        this.loadingSolicitation = true;

        const selectedSlips = this.contractsData[contractId].selected;

        let paidFields = this.$refs['paidValue'];
        for (const field of paidFields) {
          if (!field.validate()) {
            return;
          }
        }

        if (!selectedSlips || selectedSlips.length === 0) return;

        const solicitationContract = this.unitContracts.find(
          ({ id }) => id === contractId
        );

        const unifiedSlips = [
          ...selectedSlips.flatMap(
            ({
              noChargeValue,
              paidValue,
              discountedValue,
              discount,
              parcelCode,
              serieId,
              serieCode,
              id,
              expirationDate,
              proRata,
              spe,
              contractQty,
              slipsUnion,
            }) => {
              let sameDocument = [
                {
                  noChargeValue,
                  discountedValue: discountedValue,
                  parcelCode,
                  serieId,
                  serieCode,
                  id,
                  expirationDate,
                  discount,
                  proRata,
                  spe,
                },
              ];
              if (contractQty >= 2) {
                for (const slipContract of slipsUnion.contracts) {
                  if (slipContract.contractId != contractId) {
                    let contractSlips =
                      this.anticipationPositionData[slipContract.contractId];

                    for (const otherSlip of slipContract.slips) {
                      let slip = contractSlips.find(
                        (s) =>
                          s.serieId === otherSlip.serieId &&
                          s.parcelCode === otherSlip.parcelCode
                      );
                      if (slip) {
                        sameDocument.push({
                          noChargeValue: slip.noChargeValue,
                          discountedValue: slip.discountedValue,
                          discount: slip.discount,
                          parcelCode: slip.parcelCode,
                          serieId: slip.serieId,
                          serieCode: slip.serieCode,
                          id: slip.id,
                          expirationDate: slip.expirationDate,
                          spe: slip.spe,
                        });
                      }
                    }
                  }
                }
              }

              let proRataValue = this.discountCampaign.releaseProRata
                ? proRata || 0.0
                : 0.0;
              let paidValueUnformated = this.parseMoneyComma(paidValue);
              let discountUnformated = parseFloat(discount);
              let integralValue = parseFloat(
                (paidValueUnformated + discountUnformated).toFixed(2)
              );

              if (integralValue !== discountedValue && discountUnformated > 0) {
                discountUnformated = 0;
                integralValue = paidValueUnformated;
                proRataValue = 0;
              }
              const total = sameDocument.reduce(
                (p, curr) => p + curr.discountedValue,
                0
              );
              const ratio = paidValueUnformated / total;

              for (const slipPartial of sameDocument) {
                slipPartial.discountedValue =
                  Math.round(slipPartial.discountedValue * ratio * 100) / 100;
              }
              // console.log({ total, ratio, sameDocument });
              return sameDocument;
            }
          ),
        ];

        const body = {
          contractId,
          contractType: solicitationContract.type,
          productSku: this.selectedUnit.sku,
          parcels: unifiedSlips,
          solicitationType: SOLICITATE_TYPE.ANTICIPATION,
          totalDiscount: 0.0,
          releaseProRata: this.discountCampaign.releaseProRata,
        };

        body.totalDiscount = body.parcels.reduce(
          (total, parcel) => total + parcel.discount,
          0
        );

        const solicitationResults = await this.requestService(
          `${process.env.FINANCIAL_API_URL}/solicitation/save`,
          'POST',
          {
            data: body,
            localErrorHandling: true,
            retries: 0,
          }
        );

        for (const solicitation of solicitationResults) {
          if (solicitation) {
            this.contractsData[contractId].solicitationStep =
              SOLICITATIONS_PAGE_STEPS.WAITING;

            this.contractsData[solicitation.contractId].solicitations.push(
              solicitation
            );

            const traceAction =
              enums.logTraceActions.anticipationPaymentSlipSolicitation;
            const traceInfo = {
              contractId: solicitation.contractId,
              contractType: solicitationContract.type,
              detachedType: this.getContractTitle(solicitationContract),
              paymentTotal: solicitation.paymentTotal,
              solicitationCode: solicitation.solicitationCode,
              expirationDate: solicitation.expirationDate,
              slips: unifiedSlips,
            };
            this.createTrace(traceAction, traceInfo);
          }
        }
        await this.$store.dispatch('solicitations/resetAnticipationSlipsCache');
        await this.getItems();
      } catch (e) {
        console.error({ ...e });

        if (e.status === 500) {
          this.error = true;
        }
      } finally {
        this.loadingSolicitation = false;
      }
    },

    async getItems() {
      try {
        this.error = false;
        this.loadingItems = true;

        const contractsToGetSlips = [...this.allowedContracts];
        let unitSolicitations = [];

        if (contractsToGetSlips.length > 0) {
          let promises = [
            this.$store.dispatch(
              'solicitations/getAnticipationSolicitations',
              contractsToGetSlips
            ),
            this.$store.dispatch('solicitations/getDiscountCampaign'),
            this.$store.dispatch(
              'solicitations/getAnticipationPaymentSlips',
              contractsToGetSlips
            ),
          ];
          let [solicitationsByContractList] = await Promise.all(promises);
          unitSolicitations = solicitationsByContractList;
        }
        /*
          interface ContractSolicitation {
            contractId: number;
            inProgress: boolean;
            error: boolean;
            ready: boolean;
            systemDischarge: boolean;
            items: SolicitationResultType[];
            logGenerated: boolean;
            logError: boolean;
            logExpired: boolean;
          }
        */
        for (const contractSolicitation of unitSolicitations) {
          let hasSomethingToShow = false;
          const contractId = contractSolicitation.contractId;

          if (contractSolicitation.systemDischarge) {
            this.contractsData[contractId].solicitations =
              contractSolicitation.items || null;
            this.contractsData[contractId].systemDischarge = true;

            hasSomethingToShow = true;
          } else if (
            contractSolicitation.inProgress ||
            contractSolicitation.error
          ) {
            this.contractsData[contractId].solicitationStep =
              SOLICITATIONS_PAGE_STEPS.WAITING;
            this.contractsData[contractId].solicitations =
              contractSolicitation.items || null;
            this.contractsData[contractId].error = contractSolicitation.error;

            hasSomethingToShow = true;
          } else if (contractSolicitation.ready) {
            // Add barcode into parcel
            for (const solicitation of contractSolicitation.items) {
              if (!solicitation.barcode) {
                for (const parcel of solicitation.parcels) {
                  const { barcode } =
                    this.anticipationPositionData[solicitation.contractId].find(
                      (s) =>
                        s.serieId === parcel.serieId &&
                        s.parcelCode === parcel.parcelCode
                    ) || {};
                  if (!solicitation.barcode && barcode) {
                    solicitation.barcode = barcode;
                  }
                }
              }
            }

            this.contractsData[contractId].solicitations =
              contractSolicitation.items;
            this.contractsData[contractId].solicitationStep =
              SOLICITATIONS_PAGE_STEPS.READY;

            hasSomethingToShow = true;
          }

          if (
            hasSomethingToShow &&
            this.contractsData[contractId].solicitations
          ) {
            const contractIndex = contractsToGetSlips.findIndex(
              (o) => o.id === contractId
            );
            if (contractIndex !== -1)
              contractsToGetSlips.splice(contractIndex, 1);
          }
        }
      } catch (err) {
        console.error(err);
        this.error = true;
      } finally {
        this.$forceUpdate();
        this.loadingItems = false;
      }
    },

    async sendSlipByEmail(item, email, fromHome = false) {
      await this.$store.dispatch('solicitations/sendSlipByEmail', {
        item,
        email,
        mode: this.mode,
        fromHome,
      });
    },
    async sendSlipBySms(item, cellphone, fromHome = false) {
      await this.$store.dispatch('solicitations/sendSlipBySms', {
        item,
        cellphone,
        mode: this.mode,
        fromHome,
      });
    },

    async getDiscountCampaign() {
      await this.$store.dispatch('solicitations/getDiscountCampaign');
      if (this.discountCampaign?.hasDiscountCampaign) {
        this.discountCampaignDescription =
          this.pageParams.texts.discountCampaignDescription;
        this.footerEmptyCols = this.footerEmptyCols + 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.input-slim {
  font-size: inherit;
}

.waiting-state {
  &__title {
    margin: 0;
    font-weight: var(--font-weight);
  }
  &__text {
    margin: 0;
    font-size: 11px;
  }
}

.indelay-slips-tooltip {
  padding: 12px 0;
}

.table-stepper-container {
  padding: 16px;

  @include breakpoint(mobile) {
    padding: 0px;
  }
}

.payment-slip-in-delay {
  &__description {
    font-size: 12px;
    padding-bottom: 10px;
    color: var(--label-color);
  }
  &__febraban {
    font-size: var(--payment-slip-in-size);
    padding-bottom: 10px;
    color: var(--payment-slip-in-color);
  }
}

>>> .v-table__overflow {
  @include breakpoint(mobile) {
    overflow-x: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/financial/AnticipationPaymentSlip.vue